import useCurrentUserAccount from 'src/hooks/useCurrentUserAccount';
import useCurrentWalletAdapter from 'src/hooks/useCurrentWalletAdapter';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import useFeatureFlagStore from 'src/stores/featureFlag/useFeatureFlagStore';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';

export const useIsElfaWidgetEligible = () => {
	const isMobileScreenSize = useIsMobileScreenSize();
	const wallet = useCurrentWalletAdapter();
	const currentAccount = useCurrentUserAccount();
	const isElfaWidgetFlagEnabled = useFeatureFlagStore((s) =>
		s.flagEnabled('ENABLE_ELFA_WIDGET')
	);
	const isEmulatingAccount = useVelocityStore((s) => s.isEmulatingAccount);
	const isEligible =
		wallet.connected &&
		currentAccount &&
		!!wallet.publicKey?.equals(currentAccount.authority) &&
		isElfaWidgetFlagEnabled &&
		!isMobileScreenSize &&
		!isEmulatingAccount;

	return isEligible;
};
